import { render, staticRenderFns } from "./XimuProtocolDialog.vue?vue&type=template&id=09c717bd&scoped=true"
import script from "./XimuProtocolDialog.vue?vue&type=script&lang=js"
export * from "./XimuProtocolDialog.vue?vue&type=script&lang=js"
import style0 from "./XimuProtocolDialog.vue?vue&type=style&index=0&id=09c717bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c717bd",
  null
  
)

export default component.exports